import { useQuery } from '@tanstack/react-query';
import { db } from '../services/db';
import { listingKeys } from './queries/useListings';

export const useHomepageListings = () => {
    return useQuery({
        // Under the shared `listings` key family so that invalidating
        // listingKeys.all (every listing mutation does) refreshes this too —
        // see the comment on listingKeys.homepage() for what broke when this
        // was the unrelated literal ['homepage-listings'].
        queryKey: listingKeys.homepage(),
        queryFn: () => db.getHomepageListings(),
        staleTime: 1000 * 60 * 5, // 5 min default
    });
};
